import React, { useState } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { getQueryClient } from "@/api";
import { contract } from "contract";
import { BlogsViewType } from "contract/enum";
import { Box, Container, Grid, Button } from "@mantine/core";
import Link from "next/link";
import Header from "@/components/Header"; 
import ResourcesLandingSection from "@/components/ResourcesLandingSection";
import WeddingFooter from "@/components/WeddingFooter";

import "bootstrap/dist/css/bootstrap.min.css";

const Index = () => {
  const router = useRouter();
  const [visibleCount, setVisibleCount] = useState(6);

  const {
    data: allBlogsData,
    isLoading: isAllBlogsLoading,
    error: allBlogsError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = getQueryClient().blogs.getAllBlogs.useInfiniteQuery(
    [contract.blogs.getAllBlogs.path, BlogsViewType.all],
    ({ pageParam }) => ({
      query: {
        pageSize: 10,
        pageNumber: pageParam?.pageNumber ?? 1,
        blogsViewType: BlogsViewType.all,
      },
    }),
    {
      getNextPageParam: (lastPage) =>
        lastPage.status === 200 &&
        lastPage.body.currentPageNumber < lastPage.body.totalPages
          ? { pageNumber: lastPage.body.currentPageNumber + 1 }
          : undefined,
    }
  );

  const results = allBlogsData?.pages.flatMap((eachPage) => {
    return eachPage.body.results;
  }) ?? [];

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 3); 
  };

  return (
    <div>
       <Head>
        <title>Uthsav | Resources</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <meta name="description" content="Uthsav Calendar" />
      </Head>
      <Header />
      
      <ResourcesLandingSection />
      <section className="home_resource">
        <Container size="xl" className="container--1">
          <Grid justify="center">
            <Grid.Col span={{ base: 12, xl: 8 }} ta="center">
             
             
            </Grid.Col>
          </Grid>

          <Grid justify="center" className="pt-5" pt={5}>
  <Grid.Col span={{ base: 12, sm: 10 }}>
  <Grid>
  {results.slice(0, visibleCount).map((num) => (
    <Grid.Col
      key={num.id}
      span={{ base: 12, md: 6, lg: 4 }}
      className="col-lg-4 col-md-6 mb-lg-5 mb-4 pr-5 pl-5"
    >
      <Box className="home_res_box">
        <Link href={`/blogsDetails/${num.id}`} passHref>
          <a style={{ textDecoration: 'none', color: 'inherit' }}>
            <Box
              className="home_res_box_img"
              style={{ backgroundImage: `url(${num.blogsImage})` }}
            />
            <h6>{num.blogsName}</h6>
            {/* <div
              className="description"
              dangerouslySetInnerHTML={{
                __html:
                  num.blogsDescription.length > 100
                    ? `${num.blogsDescription.substring(0, 105)}...`
                    : num.blogsDescription,
              }}
            /> */}
          </a>
        </Link>
        <Link className ='home_plan_box' href={`/blogsDetails/${num.id}`} passHref>
          <a className="gt_start">Learn more</a>
        </Link>
      </Box>
    </Grid.Col>
  ))}
</Grid>

  </Grid.Col>
</Grid>

          {/* Show More Button */}
          {visibleCount < results.length && (
            <div className="text-center mt-4 show-more-btn">
              <Button onClick={handleShowMore} variant="outline">
                Show More
              </Button>
            </div>
          )}
        </Container>
      </section>
      <WeddingFooter />
    </div>
  );
};

export default Index;
